module.exports = __webpack_public_path__ + "static/media/balloons.b91c48a3.png";